import React from "react";
import { ListItemText, Typography, DialogTitle } from "@material-ui/core";
import { emailService } from "../../../../services";
import { SearchDialog } from "../../../common/SearchDialog";
import { submitAttachEmail } from "../../../../redux/actions";
import { useDispatch } from "react-redux";
import { utcToLocalDateTime } from "../../../../utils/dateUtils";
export const EmailAttachDialog = ({ isDialogOpen, onDialogClose, caseId, }) => {
    const dispatch = useDispatch();
    return (React.createElement(SearchDialog, { label: "email", name: "email-attachments", service: emailService, dialogOpenProps: { isDialogOpen, initialSearchText: "" }, onSelectOrClose: val => {
            var id = val === null || val === void 0 ? void 0 : val.id;
            if (id) {
                dispatch(submitAttachEmail(caseId, id));
            }
            onDialogClose();
        }, renderItem: item => (React.createElement(ListItemText, { primary: React.createElement("span", null,
                React.createElement("strong", null,
                    item["fromEmailAddress"],
                    item["receivedDateTime"] && React.createElement("span", null, " - "),
                    utcToLocalDateTime(item["receivedDateTime"])),
                React.createElement("br", null),
                item["subject"]), secondary: `
          ${item["bodyPreview"] || ""}` })), titleCustomElement: React.createElement(DialogTitle, null,
            React.createElement(Typography, { variant: "body1" },
                "Select an email from your Outlook ",
                React.createElement("strong", null, "Complaints"),
                " folder:")) }));
};
